<template>
    <span>
        <template v-if="tooltip">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-on="on"
                        :text="flat"
                        :color="color"
                        :icon="iconOnly"
                    >
                        <v-icon
                            :small="smallIcon"
                            class="pr-1"
                            v-if="icon"
                        >
                            {{ icon }}
                        </v-icon>
                        <span v-if="!iconOnly">
                        {{ number }}
                    </span>
                    </v-btn>
                </template>
                <span>{{ number }}</span>
            </v-tooltip>
        </template>
        <template v-else>
            <v-btn
                :text="flat"
                :color="color"
                :icon="iconOnly"
            >
                <v-icon
                    :small="smallIcon"
                    class="pr-1"
                    v-if="icon"
                >
                    {{ icon }}
                </v-icon>
                <span v-if="!iconOnly">
                    {{ number }}
                </span>
            </v-btn>
        </template>
    </span>
</template>
<script>
    export default {
        data() {
            return {}
        },
        name: 'Click-To-Call',
        props: {
            'number': {
                required: true
            },
            'iconOnly': {
                default: false
            },
            'icon': {
                type: String,
                default: ''
            },
            'smallIcon': {
                default: true
            },
            'flat': {
                type: Boolean,
                default: false
            },
            'color': {
                type: String,
                default: ''
            },
            'tooltip': {
                default: false
            },
        },
        mounted() {
        },
        methods: {},
    }
</script>
